import { createSlice } from "@reduxjs/toolkit";
import { SeoCrawler } from "../../types/index.js";
import { getSeoCrawler, patchSeoUrl, postSeoCrawler } from "./actions.js";

const initialState: SeoCrawler = {
  status: "uninitialized",
  crawledAt: null,
  errors: 0,
};

const slice = createSlice({
  name: "seo/crawlers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      getSeoCrawler.fulfilled,
      (_state, action) => action.payload,
    );

    builder.addCase(
      postSeoCrawler.fulfilled,
      (_state, action) => action.payload,
    );

    builder.addCase(patchSeoUrl.pending, (state, action) => {
      const { arg, url } = action.meta;
      const { request } = arg;
      if (!url) return;

      let { errors } = state;
      if (!url.pageTranslationId && request.pageTranslationId) {
        errors--;
      } else if (!url.isArchived && request.isArchived) {
        errors--;
      } else if (url.isArchived && !request.isArchived) {
        errors++;
      } else if (url.pageTranslationId && !request.pageTranslationId) {
        errors++;
      }

      if (errors >= 0) {
        state.errors = errors;
      }
    });
  },
});

export default slice.reducer;
